import React from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import PriceList from './PriceList';
import CallToAction from './CallToAction';
import Testimonials from './Testimonials';
import Gallery from './Gallery';
import Blog from './Blog';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <PriceList />
      <CallToAction />
      <Testimonials />
      <Gallery />
      <Blog />
      <Contact />
    </>
  );
};

export default Home;
